export default class Search {
  constructor() {
    this.init();
  }

  init() {
    const searchButton = document.querySelector('.search-button');
    const searchPanel = document.querySelector('.search-panel');
    const closeButton = searchPanel.querySelector('.cta-button');
    const searchInput = searchPanel.querySelector('input[type="search"]');

    const onKeydown = (e) => {
      if (e.key === 'Escape') {
        closePanel();
        setTimeout(() => searchButton.focus(), 100);
      }
    };

    function closePanel() {
      searchButton.setAttribute('aria-expanded', 'false');
      searchPanel.classList.remove('active');

      document.removeEventListener('keydown', onKeydown);
    }

    function openPanel() {
      searchButton.setAttribute('aria-expanded', 'true');
      searchPanel.classList.add('active');
      setTimeout(() => searchInput.focus(), 300);
      document.addEventListener('keydown', onKeydown);
    }

    searchButton.addEventListener('click', () => {
      openPanel();
    });

    closeButton.addEventListener('click', (e) => {
      closePanel();
      setTimeout(() => searchButton.focus(), 100);
    });

    searchPanel.addEventListener('focusout', function(event) {
      if (searchPanel.contains(event.relatedTarget)) return;

      if (searchPanel.classList.contains('active')) {
        closePanel();
      }
    });
  }
}
